'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.subnavScrollHandler = exports.hasSubnav = undefined;

var _setup = require('./setup.js');

var _globalUi = require('./global-ui.js');

var _stickybits = require('stickybits');

var _stickybits2 = _interopRequireDefault(_stickybits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//products & recipes have same subnav
var hasSubnav = exports.hasSubnav = !!_setup.s.$productsubnav.length;

var $herobg = $('#nx-product-herobg');
var $heroctrls = $('#nx-producthero-ctrls');

// Subnav -----------//
//subnav clone/swap
var subnavSwap = function subnavSwap() {
	return _setup.s.$productsubnavTarget.append(_setup.s.$productsubnav.detach());
};

//thumbnail in nav
var doSubnavThumbnail = function doSubnavThumbnail() {
	var $thumb = _setup.s.$productsubnav.find('[data-product-thumbnail]');
	$thumb.append('<img src="' + $thumb.data('product-thumbnail') + '">');
};

var subnavTitleSizer = function subnavTitleSizer() {
	var $title = _setup.s.$productsubnav.find('.nx-subnav--title');
	var $span = $title.find('.nx-subnav--name h4 > span');
	var titlewidth = $title.width();
	var spanwidth = $span.width();

	$span.css({ width: $title.width() + 'px' });
};

var doProductSubnav = function doProductSubnav() {
	_setup.s.$doc.on('nx.scroll.start', function () {
		_setup.s.quickWrite(subnavSwap);

		setTimeout(function () {
			return subnavTitleSizer();
		}, 200);
		if (_setup.s.issingleproduct) {
			doSubnavThumbnail();
		}
	});
};

if (_setup.s.$productsubnav.length) {
	doProductSubnav.call();
	_setup.s.$window.on('resize load', $.debounce(250, subnavTitleSizer));
}

//scroll handler / page tick
var subnavScrollHandler = exports.subnavScrollHandler = function subnavScrollHandler() {};

function productHeroBehavior() {
	var $heroarea = $(_setup.s.$productsubnav.data('show-after'));

	var $detailCol = $('.nx-producthero--col');
	var $detailsOuter = $('#nx-producthero-details');
	var $detailsParent = $detailsOuter.parent();

	var heroHeight = void 0,
	    heroBottom = void 0,
	    columnTop = void 0,
	    columnWidth = void 0,
	    detailsTop = void 0;

	var subnavPropsRefresh = function subnavPropsRefresh() {
		if (!$heroarea.length) return;

		heroHeight = $heroarea.outerHeight();
		heroBottom = $heroarea.offset().top + heroHeight;

		if (_setup.s.issingleproduct) {
			columnTop = $detailCol.offset().top;
			columnWidth = $detailsParent.width();
			detailsTop = $detailsOuter.offset().top;
		}
	};

	var setColumnHeight = function setColumnHeight() {
		if (_globalUi.bp.breakpointUp('md')) {
			$detailCol.css({ height: heroHeight - (columnTop - _setup._s.headerHeight) + 'px' });
		} else if ($detailCol.css('height') !== 'auto') {
			$detailCol.css({ height: 'auto' });
		}
	};

	exports.subnavScrollHandler = subnavScrollHandler = function subnavScrollHandler() {
		if (_setup._s.scrollCurrent > heroBottom) {
			_setup.s.$body.addClass('is-showing-subnav');
		} else {
			_setup.s.$body.removeClass('is-showing-subnav');
		}
	};

	var runSubnav = function runSubnav() {
		subnavPropsRefresh.call();
		if (_setup.s.issingleproduct) {
			setColumnHeight.call();
		}
	};

	_setup.s.$doc.ready(runSubnav);
	_setup.s.$window.load(subnavPropsRefresh);
	_setup.s.$window.resize($.debounce(550, runSubnav));
}

if (hasSubnav) {
	productHeroBehavior.call();
}

//Scroll Magic stuff -------------------------------------------------//

function productScrollMagic() {
	if (!_setup.s.issingleproduct) return;

	var $detailCol = $('.nx-producthero--col');
	var $heroarea = $('.nx-producthero');
	var $herobg = $('#nx-product-herobg');
	var $sliderOuter = $('.nx-producthero--slider-outer');

	var $detailsOuter = $('#nx-producthero-details');
	var $stickyEl = $detailsOuter.find('.nx-producthero--col-liner');
	var $detailsParent = $detailsOuter.parent();

	var cachedWidth = function cachedWidth() {
		return $detailsOuter.width();
	};

	if (_globalUi.bp.breakpointUp('md')) {
		(0, _stickybits2.default)('.nx-producthero--col-liner', {
			stickyBitStickyOffset: 20,
			useFixed: true
		});

		_setup.s.$window.scroll(function () {
			return $detailsOuter.width(cachedWidth());
		});
		_setup.s.$window.resize(function () {
			if (_globalUi.bp.breakpointDown('md')) {
				$detailsOuter.width('auto');
				return;
			}

			(0, _stickybits2.default)('.nx-producthero--col-liner').cleanup();
		});
	}

	//sidebar controller
	var sbSceneDisabled = false;

	//heroimg controller
	var $heroHeadline = $('.nx-producthero--headline');
	var heroCtrl = new ScrollMagic.Controller();
	var heroScene = new ScrollMagic.Scene({
		triggerElement: '#nx-heroscene-pin',
		offset: _setup.s.$window.height() / 2
	}).addTo(heroCtrl);

	TweenMax.set($heroctrls, { autoAlpha: 0 });

	heroScene.on('enter', function (e) {
		if (!_globalUi.bp.breakpointUp('md')) return;
		_setup.s.$main.addClass('nx-producthero-out');
		TweenMax.to($herobg, 0.35, { autoAlpha: 0, ease: Linear.easeNone });
		TweenMax.to($heroHeadline, 0.5, { autoAlpha: 0, y: -50, ease: Expo.easeOut });
		TweenMax.set($heroctrls, { autoAlpha: 0, y: -30 });
		TweenMax.to($heroctrls, 1.2, { autoAlpha: 1 });
	});

	heroScene.on('leave', function (e) {
		if (!_globalUi.bp.breakpointUp('md')) return;
		_setup.s.$main.removeClass('nx-producthero-out');
		TweenMax.to($herobg, 0.35, { autoAlpha: 1, ease: Linear.easeNone });
		TweenMax.to($heroHeadline, 0.75, { autoAlpha: 1, y: 0, ease: Expo.easeOut });
		TweenMax.to($heroctrls, 0.75, { autoAlpha: 0 });
	});

	// s.$window.resize($.debounce(350, sbResizeHandler));
}

_setup.s.$window.on('nx.page.loaded', function () {
	return productScrollMagic.call();
});
_setup.s.$doc.ready(function () {
	return productScrollMagic.call();
});

// Product Features List -----------------------------------------------//
function productFeatureList() {
	if (_setup.s.$productFeaturesBottom.length === 0) return;

	var $featureimgs = $('.nx-featurelist--item-img');
	var $featurebody = $('.nx-featurelist--item-body');
	var featureListEqualize = function featureListEqualize() {
		if (_globalUi.bp.breakpointUp('md')) {
			$featurebody.css({ height: $featureimgs.height() + 'px' });
		} else {
			$featurebody.attr('style', '');
		}
	};
	_setup.s.$doc.ready(featureListEqualize);
	_setup.s.$window.resize($.debounce(300, featureListEqualize));
}
productFeatureList.call();

// Product Slider -----------------------------------------------//
function productSlider() {
	if (_setup.s.$singleProductSlider.length === 0) return;
	var $slides = _setup.s.$singleProductSlider.find('.nx-producthero--slide');
	if ($slides.length < 2) return;

	var flkty = _setup.s.$singleProductSlider.flickity({
		slideSelector: '.nx-producthero--slide',
		setGallerySize: false,
		lazyLoad: 1,
		pageDots: false,
		prevNextButtons: false,
		dragThreshold: Modernizr.touchevents ? 15 : 2
	}).data('flickity');

	var $rarr = _setup.slider.getSliderBtnHtml('Next', 'nx-producthero-nextbtn');
	var $larr = _setup.slider.getSliderBtnHtml('Prev', 'nx-producthero-prevbtn');
	var counter = _setup.slider.getSliderCounter(flkty);

	$heroctrls.prepend($rarr, $larr, counter.html);
	$heroctrls.find('.nx-slider--counter').prepend(counter.$current);

	$larr.click(function () {
		return _setup.s.slidePrevHandler(flkty);
	});
	$rarr.click(function () {
		return _setup.s.slideNextHandler(flkty);
	});

	flkty.on('select', function () {
		return _setup.slider.updateSliderCounter(counter.$current, flkty.selectedIndex + 1);
	});

	//hero bg img parallax thing - no go - frame rate bad
	//flkty.on('scroll', (progress) => TweenMax.set($herobg, {x: -(progress * 10).toFixed(0)+'%'}) );
}

productSlider.call();


//////////////////
// WEBPACK FOOTER
// ./_js/product-single.js
// module id = 1
// module chunks = 0